import React, { Component } from 'react';
import { connect } from 'react-redux';

import previewPdf from './../../assets/images/placeholder/pdf-placeholder.jpg';

class PrinterDoc extends Component {
	render() {
		return (
			<div className="modal fade px-0" id="printerDoc" aria-labelledby="printerDocLabel" aria-hidden="true">
				<div className="modal-dialog px-2 container-default">
					<div className="modal-content">
						<header className="modal-header">
							<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">User deceased</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="printerDocLabel">impression de documents</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						</header>
						<div className="modal-body scroll-default py-0">
							<div className="row grid-sm grid-lg-2 grid-xl-3 align-items-center gx-1">
								<div className="col-12 col-lg justify-content-around grid-column-xl-2">
									<div className="card paper-shadow border-0 h-100 mx-auto container-lg-copy">
										<img className="img-fluid img-contain" src={previewPdf} width="100%" alt="pdf preview" />
									</div>
								</div>
								<div className="col-12 col-lg h-100">
									<div className="card rounded rounded-top-left-sm border-none">
										<div className="card-body">
											<h5 className="h3 font-weight-bolder mb-2">Chronologie</h5>
											<p className="h6 mb-auto pb-2"><i className="eva eva-radio-button-on text-success mr-1 align-middle"></i>Validation et soumission à AGEESMA</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer pt-0">
							<button type="button" className="btn btn-faded" data-dismiss="modal">Annuler</button>
							<button type="button" className="btn btn-info" data-dismiss="modal">Imprimer</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(PrinterDoc);